var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 56,
    viewBox: "0 0 50 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.65848 6.39844L0 17.5H23.2143V3.5H10.4576C8.42634 3.5 6.57366 4.62656 5.65848 6.39844ZM26.7857 17.5H50L44.3415 6.39844C43.4263 4.62656 41.5737 3.5 39.5424 3.5H26.7857V17.5ZM50 21H0V45.5C0 49.3609 3.20312 52.5 7.14286 52.5H42.8571C46.7969 52.5 50 49.3609 50 45.5V21Z",
    fill: "#828284"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_501_3987)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 47C31.0758 47 36 42.2996 36 36.5C36 30.7004 31.0758 26 25 26C18.9242 26 14 30.7004 14 36.5C14 42.2996 18.9242 47 25 47ZM21.2961 32.7799C21.6355 31.8652 22.5465 31.25 23.5648 31.25H26.0699C27.5695 31.25 28.7812 32.4107 28.7812 33.8381C28.7812 34.765 28.2613 35.6223 27.4191 36.0857L26.0312 36.8445C26.0227 37.3777 25.5629 37.8125 25 37.8125C24.4285 37.8125 23.9688 37.3736 23.9688 36.8281V36.2744C23.9688 35.9217 24.1664 35.5977 24.4887 35.4213L26.3922 34.3795C26.5941 34.2688 26.7188 34.0637 26.7188 33.8422C26.7188 33.4977 26.4266 33.2229 26.0699 33.2229H23.5648C23.4187 33.2229 23.2898 33.309 23.2426 33.4402L23.2254 33.4895C23.0363 34.0021 22.4434 34.2688 21.9105 34.0883C21.3777 33.9078 21.0941 33.3418 21.2832 32.8332L21.3004 32.784L21.2961 32.7799ZM26.375 40.4375C26.375 41.1635 25.7605 41.75 25 41.75C24.2395 41.75 23.625 41.1635 23.625 40.4375C23.625 39.7115 24.2395 39.125 25 39.125C25.7605 39.125 26.375 39.7115 26.375 40.4375Z",
    fill: "#FAFBFC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_501_3987"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 21,
    fill: "white",
    transform: "translate(14 26)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.b1f34ade61a3f369674ad784f9a458e9.svg";
export { ForwardRef as ReactComponent };